var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"home"},[_c('PageHeader'),_c('HomeHeader'),_c('div',{staticStyle:{"min-height":"600px"}},[_c('router-view',{key:_vm.$route.fullPath,staticStyle:{"padding-bottom":"35px"}})],1),_c('RightSideBar'),_c('PageFooter')],1)}
var staticRenderFns = []

export { render, staticRenderFns }